// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.margin-40[data-v-1efb1464] {\n    margin: 40px;\n}\n.input-absolute[data-v-1efb1464] {\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 999999px;\n}\n.cd-modal-block[data-v-1efb1464] {\n    margin: 20px 10px;\n}\n.margin-10-0[data-v-1efb1464] {\n    margin: 10px 0;\n}\n.modal-textarea[data-v-1efb1464] {\n    resize: none;\n    /*width: 910px;*/\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
